var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.3333L25 23.3333M20 18.3333V35V18.3333ZM20 18.3333L15 23.3333L20 18.3333Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39002 15.195C6.8137 15.5917 5.43648 16.5503 4.51711 17.8907C3.59773 19.2312 3.19949 20.8613 3.3972 22.4747C3.5949 24.088 4.37495 25.5737 5.59079 26.6525C6.80663 27.7313 8.37457 28.329 10 28.3333H11.6667",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3834 11.8967C25.8138 9.64095 24.4077 7.68623 22.4503 6.42876C20.4929 5.17129 18.1306 4.70515 15.8422 5.12484C13.5538 5.54453 11.5107 6.81864 10.1269 8.68889C8.74308 10.5592 8.1222 12.8856 8.3901 15.1967C8.3901 15.1967 8.6451 16.6667 9.16677 17.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3334 28.3333C29.5101 28.3325 30.6734 28.0825 31.7465 27.5998C32.8197 27.117 33.7784 26.4124 34.5596 25.5324C35.3408 24.6525 35.9268 23.617 36.2791 22.4942C36.6313 21.3714 36.7417 20.1868 36.603 19.0182C36.4644 17.8497 36.0799 16.7238 35.4747 15.7146C34.8696 14.7053 34.0576 13.8357 33.0921 13.163C32.1267 12.4902 31.0297 12.0295 29.8734 11.8113C28.7171 11.593 27.5277 11.6221 26.3834 11.8967L24.1667 12.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.0e36a95b.svg";
export { ForwardRef as ReactComponent };